/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramPeriod } from '../../models/program-period';

export interface CreateAdminProgramPeriod$Params {
  body: ProgramPeriod;
}

export function createAdminProgramPeriod(
  http: HttpClient,
  rootUrl: string,
  params: CreateAdminProgramPeriod$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ProgramPeriod>> {
  const rb = new RequestBuilder(rootUrl, createAdminProgramPeriod.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProgramPeriod>;
    })
  );
}

createAdminProgramPeriod.PATH = '/admin/program-periods';
